import isDomUsable from '@fenderdigital/utils/dom';

const MENU_WIDTH = '13.75rem';
const PROFILE_URL = isDomUsable()
  ? `${process.env.REACT_APP_CLIENT_FENDER_COM}/profile/info`
  : null;

/**
 * Returns the client width of the window.
 */
function getWindowWidth(): number | null {
  return isDomUsable() ? window.innerWidth : null;
}

/**
 * Parses id into expected updateUser Segment event value
 *
 * @param {String} id ID to parse
 * @return {String}
 */
function getCurrentLevel(id: string): string {
  return `Level ${id.split('-')[3]}`;
}

/**
 * Parses id into navigation_label Avo propety value
 *
 * @param {String} id ID to parse
 * @return {String}
 */
function getNavigationLabel(id: string): string {
  const arr = id.split('-').slice(1);
  return arr.join(' ');
}

export { MENU_WIDTH, PROFILE_URL, getWindowWidth, getCurrentLevel, getNavigationLabel };
